import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Typography
} from '@mui/material';

function SessionTimeoutModal({ 
  open, 
  onExtend, 
  onLogout, 
  timeRemaining, 
  isExtending 
}) {
  const [countdown, setCountdown] = useState(Math.floor(timeRemaining / 1000));

  useEffect(() => {
    if (!open) return;
    
    setCountdown(Math.floor(timeRemaining / 1000));
    
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [open, timeRemaining]);

  return (
    <Dialog
      open={open}
      aria-labelledby="session-timeout-dialog-title"
      aria-describedby="session-timeout-dialog-description"
    >
      <DialogTitle id="session-timeout-dialog-title">
        Your session is about to expire
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="session-timeout-dialog-description">
          Due to inactivity, your session will expire in:
        </DialogContentText>
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
          <Typography variant="h4" color="error">
            {countdown} seconds
          </Typography>
        </Box>
        <DialogContentText>
          Would you like to continue working?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="secondary">
          Logout
        </Button>
        <Button 
          onClick={onExtend} 
          color="primary" 
          variant="contained" 
          autoFocus
          disabled={isExtending}
          startIcon={isExtending ? <CircularProgress size={20} /> : null}
        >
          {isExtending ? 'Extending...' : 'Yes, keep me signed in'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SessionTimeoutModal; 